import { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withApollo } from '@apollo/client/react/hoc';
import { history } from 'components/root';
import gql from 'graphql-tag';
import Path from 'path-to-regexp';

import { ROUTE_INSPECT_TRACE } from 'constant/routes';
import { formatDate } from 'utils';

import { AvatarComponent } from '@/components/ui/avatar/avatar';

export class TraceCard extends Component {
  static propTypes = {
    trace: PropTypes.object.isRequired
  };

  renderTitle = () => {
    const { trace } = this.props;

    return (
      <div
        className="cursor-pointer text-[13px]"
        onClick={this.handleTitleClick}
        data-cy="trace-card-title"
      >
        {trace.name}
      </div>
    );
  };

  handleTitleClick = () => {
    const {
      trace: { rowId }
    } = this.props;

    history.push(Path.compile(ROUTE_INSPECT_TRACE)({ id: rowId }));
  };

  render = () => {
    const { trace } = this.props;

    // Links are created by an account.
    // However, its entity can be null if the current user is a collaborator
    // and the entity is not visible to the group.
    // The display falls back to the link group in that case.
    const { avatar } = trace.head.createdByAccount?.entity || trace.head.group;

    return (
      <div className="border-border bg-card box-border h-[63px] rounded-md border">
        <div className="flex grow flex-col justify-between p-[7px]">
          <div className="relative">
            <div className="absolute top-0 right-[49px] left-0">
              {this.renderTitle()}
            </div>
          </div>
          <div className="relative">
            <div className="absolute bottom-0 left-0 flex items-center">
              <div className="text-card-foreground mr-[7px] text-base">
                {trace.head.height.toString().padStart(2, '0')}
              </div>
              <div className="relative">
                <AvatarComponent source={avatar} />
              </div>
            </div>
            <div className="absolute right-0 bottom-0 flex items-center justify-end">
              <div className="text-muted-foreground text-xs tracking-wider capitalize">
                {formatDate(trace.head.createdAt)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

export const fragments = {
  trace: gql`
    fragment TraceCardFragment on Trace {
      rowId
      name
      head {
        processState
        height
        createdAt
        linkHash
        createdByAccount {
          rowId
          entity {
            __typename
            ... on Account_User {
              rowId
              avatar
            }
            ... on Account_Bot {
              rowId
              avatar
            }
          }
        }
      }
    }
  `
};

export default compose(withApollo)(TraceCard);
